import {MODE_TIME_CLOCK} from '@/library/modules/time-tracker/time-tracker';
import {type GetterTree} from 'vuex';
import {telephoneStatuses} from '@/library/modules/employee/employee';

const getters: GetterTree<TelephoneToolbarState, RootState> = {
    statusList(state, getters, rootState)
    {
        let statusList = {};
        for (let employeeId in state.employees)
        {
            if (!state.employees.hasOwnProperty(employeeId))
            {
                continue;
            }

            const timeTrackerMode: number|undefined = rootState.layoutData.employee_configuration?.time_tracker_mode;

            let employee = state.employees[employeeId];
            let status   = employee.status;

            if (telephoneStatuses[status] && telephoneStatuses[status].onlyTimeClock && timeTrackerMode && !(timeTrackerMode & MODE_TIME_CLOCK))
            {
                continue;
            }

            if (telephoneStatuses[status] && typeof telephoneStatuses[status].groupWith !== 'undefined')
            {
                status = telephoneStatuses[status].groupWith;
            }

            if (typeof statusList[status] === 'undefined')
            {
                statusList[status]       = Object.assign({}, telephoneStatuses[status]);
                statusList[status].count = 0;
            }
            statusList[status].count++;
        }

        return statusList;
    },

    employees(state)
    {
        return state.employees;
    },
};

export default getters;